import PropertySidebarLayoutContainer from "../../../../components/property/detail/PropertySidebarLayout";

const PropertySidebarLayout = () => {
  return <PropertySidebarLayoutContainer />;
};

export default PropertySidebarLayout;
